/*
 * Copyright (c) 2009 Macrofocus GmbH. All Rights Reserved.
 */
package org.mkui.graphics.line

class BresenhamLineDrawer : LineDrawer {
    override fun drawLine(x0: Int, y0: Int, x1: Int, y1: Int, width: Int, height: Int, visitor: LineDrawer.LineVisitor, drawFirstPoint: Boolean) {
        var x0 = x0
        var y0 = y0
        var dy = y1 - y0
        var dx = x1 - x0
        val stepy: Int
        if (dy < 0) {
            dy = -dy
            stepy = -1
        } else {
            stepy = 1
        }
        val stepx: Int
        if (dx < 0) {
            dx = -dx
            stepx = -1
        } else {
            stepx = 1
        }
        dy = dy shl 1 // dy is now 2*dy
        dx = dx shl 1 // dx is now 2*dx
        if (drawFirstPoint) {
            visitor.process(x0, y0)
        }
        if (dx > dy) {
            var fraction = dy - (dx shr 1) // same as 2*dy - dx
            while (x0 != x1) {
                if (fraction >= 0) {
                    y0 += stepy
                    fraction -= dx // same as fraction -= 2*dx
                }
                x0 += stepx
                fraction += dy // same as fraction -= 2*dy
                visitor.process(x0, y0)
            }
        } else {
            var fraction = dx - (dy shr 1)
            while (y0 != y1) {
                if (fraction >= 0) {
                    x0 += stepx
                    fraction -= dy
                }
                y0 += stepy
                fraction += dx
                visitor.process(x0, y0)
            }
        }
    }
}